import ShippingAddressDTO from "@/dto/ShippingAddressDTO";
import WaybillTemplateDTO from "@/dto/template/WaybillTemplateDTO";

/**
 * 打印批次
 */
export interface PrintBatch {
    id?: number;

    /**
     * 打印单号数量
     */
    count: number;

    shippingAddress: ShippingAddressDTO;

    template: WaybillTemplateDTO;

    copies: number;

    created: number;

    printerName: string;

    /**
     * 当日第几次打单
     */
    timesPrintingInDay: number;
}

/**
 * 打印任务对应的打印批次表
 */
export interface PrintBatchTask {
    id?: number;

    batchId: number;

    printTaskId: string;

    ewaybillCount: number;
}

/**
 * 打印结构
 */
export enum PrintResultStatus {
    /**
     * 页面关闭
     */
    CLOSE_WINDOW = "CLOSE_WINDOW",
    /**
     * 处理中
     */
    PROCESSING = "PROCESSING",
    /**
     * 成功
     */
    SUCCESS = "SUCCESS",
    /**
     * 失败
     */
    FAIL = "FAIL",
}

/**
 * 运单号的打印序列
 */
export interface WaybillNoDocumentNumberResult {
    id?: number;

    waybillNo: string;

    documentNumber: number;

    totalNumber: number;

    /**
     * 创建时间
     */
    created: number;
}

export interface PrintResult {
    id?: number;
    /**
     * 打印批次id
     */
    batchId: number;

    waybillNo: string;

    status: PrintResultStatus;

    message: string;

    /**
     * 在具体的那一个打印任务id 打印机返回的
     */
    printTaskId: string;
}
